import { ButtonControl } from "@/Common/Components/Buttons/ButtonControl";
import { Popup } from "@/Common/Components/Modals/Popup";
import * as LocalPatientOperations from "@/Common/Operations/operations.patient.local";

interface IComboAppointmentWarningPopupProps {
    OkClickedTargetOperation: number;
    CancelClickTargetOperation: number;
}

class ComboAppointmentWarningPopup extends React.Component<IComboAppointmentWarningPopupProps, never> {
    public render(): JSX.Element {
        return (
            <Popup title={cacheStore.GetString("EDITLabel")} cssClass="double-booking" closeTarget={LocalPatientOperations.History.Appointment_CancelModifyAppointment}>
                <div className="p-body">
                    <div className="portal-appointment-edit-warning">
                        <span> <i> {cacheStore.GetString("CancelComboAppointmentPortalLabel")} </i></span>
                    </div>
                </div>
                <div className="p-footer">
                    <div className="col-lg-12 col-md-12 col-sm-12 columns flex-display flex-gap-xs flex-end">
                        <ButtonControl
                            onClick={() => sessionStore.dispatch(this.props.CancelClickTargetOperation)}
                            label={cacheStore.GetString("CancelLabel")}
                            className="btn btn-default"
                        />
                        <ButtonControl
                            onClick={() => sessionStore.dispatch(this.props.OkClickedTargetOperation)}
                            label={cacheStore.GetString("OKLabel")}
                            variant="brand"
                        />
                    </div>
                </div>
            </Popup>
        );
    }
}

export { ComboAppointmentWarningPopup };
